import { RefreshCcw, RotateCcw, TrendingDown, TrendingUp, type LucideIcon } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type BadgeVariant = 'outline' | 'secondary';

const TX_TYPES: Record<
  number,
  { label: string; icon: LucideIcon; variant: BadgeVariant; tone: string }
> = {
  1: {
    label: '充值',
    icon: TrendingUp,
    variant: 'outline',
    tone: 'border-success/20 bg-success/5 text-success',
  },
  2: { label: '消耗', icon: TrendingDown, variant: 'secondary', tone: 'bg-muted/50' },
  3: {
    label: '清零',
    icon: RefreshCcw,
    variant: 'outline',
    tone: 'border-destructive/20 bg-destructive/5 text-destructive',
  },
  4: {
    label: '冲正',
    icon: RotateCcw,
    variant: 'outline',
    tone: 'border-orange-300 bg-orange-50 text-orange-600',
  },
};

const FALLBACK = {
  label: '清零',
  icon: RefreshCcw,
  variant: 'outline' as BadgeVariant,
  tone: 'border-destructive/20 bg-destructive/5 text-destructive',
};

/** 流水类型徽章:充值/消耗/清零/冲正,各自图标与配色;compact 用于紧凑列表(更小、无图标),reversed 置灰。 */
export function TransactionTypeBadge({
  type,
  reversed,
  compact,
}: {
  type: number;
  reversed?: boolean;
  compact?: boolean;
}) {
  const t = TX_TYPES[type] ?? FALLBACK;
  const Icon = t.icon;
  return (
    <Badge
      variant={t.variant}
      className={cn(
        'gap-1 font-bold',
        compact ? 'h-4 px-1 text-[9px]' : 'h-5 px-1.5 text-[10px]',
        t.tone,
        reversed && 'opacity-40',
      )}
    >
      {!compact && <Icon className="h-2.5 w-2.5" />}
      {t.label}
    </Badge>
  );
}

/** 已作废标记,常与 TransactionTypeBadge 并排显示。 */
export function VoidedBadge({ compact }: { compact?: boolean }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'border-destructive/30 text-destructive',
        compact ? 'h-4 px-1 text-[9px]' : 'h-5 px-1.5 text-[10px]',
      )}
    >
      已作废
    </Badge>
  );
}
